import {Gender} from "../enums/enums";

const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const mobilePattern = /^(?:\+91[-\s]?|91[-\s]?|0)?[1-9]\d{9}$/;
const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;

export const customerSchema = () => {
    return (
        {
            fName: {
                type: 'text',
                label: 'First name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            lName: {
                type: 'text',
                label: 'Last name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            phone: {
                type: 'text',
                label: 'Mobile',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Mobile is required';
                    if (!mobilePattern.test(value)) return "Please enter a valid Indian phone number (e.g. 9876543210, +919876543210, 01722001234)";
                    return null;
                },
            },
            email: {
                type: 'email',
                label: 'Email',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!value) return null;
                    if (!emailPattern.test(value)) return 'Invalid email';
                    return null;
                },
            },
            gender: {
                type: 'select',
                label: 'Gender',
                options: Gender,
                enums: true,
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Gender is required';
                    return null;
                },
            },
            gstNumber: {
                type: 'text',
                label: 'Gst Number',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!value) return null;
                    if (!gstPattern.test(value)) return 'Invalid gst number';
                },
            },
            address: {
                label: "Address",
                type: 'object',
                properties: {
                    officeNo: {
                        type: 'text',
                        label: 'Office No/ House No',
                        columns: {md: 12, lg: 6},
                        validation: (value) => {
                            if (!value) return null;
                        },
                    },
                    floor: {
                        type: 'text',
                        label: 'Floor',
                        columns: {md: 12, lg: 6},
                        validation: (value) => {
                            if (!value) return null;
                        },
                    },
                    address: {
                        type: 'textarea',
                        label: 'Address',
                        columns: {md: 12, lg: 6},
                        validation: (value) => {
                            if (!value) return null;
                        },
                    },
                }
            }
        }
    )
}

